import React, { useState } from "react";
import { ChevronDown, ChevronRight, Copy, Info } from "lucide-react";
import { toast } from "sonner";

// Variables auto-resueltas desde LexDuo (dot-notation + aliases)
const VARIABLES = [
  {
    group: "Expediente (LexDuo)",
    items: [
      { key: "expediente.numero", desc: "Número del expediente (p.ej. EXP14130)" },
      { key: "expediente.asunto", desc: "Título / asunto del expediente" },
      { key: "expediente.juzgado", desc: "Juzgado asignado" },
      { key: "expediente.materia", desc: "Rama / materia (Civil, Penal…)" },
      { key: "expediente.fase", desc: "Fase del procedimiento" },
      { key: "expediente.estado", desc: "Estado del expediente" },
      { key: "expediente.contrario", desc: "Parte contraria" },
      { key: "expediente.procurador", desc: "Procurador asignado" },
      { key: "expediente.nig", desc: "NIG judicial" },
      { key: "expediente.fecha_inicio", desc: "Fecha de apertura" },
      { key: "expediente.valor_economico", desc: "Cuantía económica" },
    ],
  },
  {
    group: "Cliente (LexDuo)",
    items: [
      { key: "cliente.nombre_completo", desc: "Nombre completo del cliente" },
      { key: "cliente.nombre", desc: "Nombre (alias)" },
      { key: "cliente.nif", desc: "NIF / CIF / DNI" },
      { key: "cliente.email", desc: "Email" },
      { key: "cliente.telefono", desc: "Teléfono" },
      { key: "cliente.direccion", desc: "Dirección" },
    ],
  },
  {
    group: "Variables libres",
    items: [
      { key: "ciudad", desc: "Ciudad de presentación (rellena manualmente)" },
      { key: "fecha", desc: "Fecha del escrito" },
      { key: "hecho_primero", desc: "Cuerpo de los hechos (libre)" },
      { key: "fundamento_primero", desc: "Cuerpo de los fundamentos (libre)" },
      { key: "suplico", desc: "Cuerpo del suplico (libre)" },
    ],
  },
];

function copy(token) {
  navigator.clipboard.writeText("{{" + token + "}}")
    .then(() => toast.success(`{{${token}}} copiado`))
    .catch(() => {});
}

export default function VariablesHelp({ defaultOpen = false, compact = false }) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div className={"border border-[#E5E7EB] rounded-sm bg-[#FBFBF9] " + (compact ? "" : "my-2")}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        data-testid="variables-help-toggle"
        className="w-full flex items-center gap-2 px-3 py-2 text-xs uppercase tracking-wider text-neutral-600 hover:bg-[#F3F4F6] transition-colors rounded-sm"
      >
        {open ? <ChevronDown className="w-3.5 h-3.5" /> : <ChevronRight className="w-3.5 h-3.5" />}
        <Info className="w-3.5 h-3.5 text-[#7B1826]" />
        Variables disponibles
      </button>
      {open && (
        <div className="px-3 pb-3 space-y-3 text-xs">
          <p className="text-[11px] text-neutral-600 leading-relaxed">
            Inserta estas variables en el cuerpo de la plantilla con doble llave: <code className="bg-white px-1 border border-[#E5E7EB] rounded-sm">{`{{expediente.numero}}`}</code>.
            Las variables <code className="bg-white px-1 border border-[#E5E7EB] rounded-sm">expediente.*</code> y{" "}
            <code className="bg-white px-1 border border-[#E5E7EB] rounded-sm">cliente.*</code> se rellenan automáticamente desde LexDuo si seleccionas expediente/contacto en el Generador.
          </p>
          {VARIABLES.map((g) => (
            <div key={g.group}>
              <div className="text-[10px] uppercase tracking-widest text-[#7B1826] font-semibold mb-1">{g.group}</div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-1">
                {g.items.map((v) => (
                  <button
                    type="button"
                    key={v.key}
                    onClick={() => copy(v.key)}
                    data-testid={`var-${v.key}`}
                    className="group text-left bg-white border border-[#E5E7EB] hover:border-[#7B1826] rounded-sm px-2 py-1.5 transition-colors flex items-start gap-1.5"
                    title={`Copiar {{${v.key}}}`}
                  >
                    <Copy className="w-3 h-3 text-neutral-400 group-hover:text-[#7B1826] shrink-0 mt-0.5" />
                    <div className="min-w-0 flex-1">
                      <code className="text-[11px] text-[#7B1826] font-mono">{`{{${v.key}}}`}</code>
                      <div className="text-[10px] text-neutral-500 truncate">{v.desc}</div>
                    </div>
                  </button>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
